import { checkDirtyStoredValue, isObjectValueType } from '@helpers'
import { CriteriaType, SEARCH_FIELD_TYPE } from '@constants'

import { POSTObjectDataFilter } from '../../../../../types'

import { getRelativeDateWithEmptyDate } from './getRelativeDateWithEmptyDate'

/**
 * Преобразование и фильтрация текущего массива с критериями в массив с заполненными значениями для тела запроса
 * @param filters - массив с текущими критериями в ассистенте
 * @returns отфильтрованный массив значений для тела запроса поиска
 */
export const transformFiltersToValuesPOST = (filters: CriteriaType[]): POSTObjectDataFilter => {
  const allValues = filters
    .map(filter =>
      filter.storedValues
        .filter(storedValue => checkDirtyStoredValue(storedValue.value, storedValue.searchRule))
        .map(storedValue => ({
          timeIncrement: storedValue.timeIncrement,
          timeWindow: Boolean(storedValue.timeIncrement),
          value: {
            JSONValue: getRelativeDateWithEmptyDate(storedValue),
            isArray:
              (isObjectValueType(storedValue.valueType) ||
                storedValue.isGroupRelated ||
                Boolean(storedValue.isFilterByObject)) &&
              Array.isArray(storedValue.value),
          },
          valueName: storedValue.name,
          valueType: storedValue.valueType,
          fieldType: storedValue.fieldType,
          objectValue: storedValue.objectValue,
          searchRule: storedValue.searchRule,
          linkedObjectCode: storedValue.linkedObjectCode,
          isGroupRelated: Boolean(storedValue.isGroupRelated),
          timeUnit: storedValue.timeUnit,
          isFilterByObject: Boolean(storedValue.isFilterByObject),
        }))
    )
    .flat()

  // Отправляем только первый фильтр Relative_value
  const relativeValueFields = allValues.filter(
    value => value.fieldType === SEARCH_FIELD_TYPE.RELATIVE_VALUE
  )
  const nonRelativeValueFields = allValues.filter(
    value => value.fieldType !== SEARCH_FIELD_TYPE.RELATIVE_VALUE
  )

  return [
    ...(relativeValueFields.length > 0 ? [relativeValueFields[0]] : []),
    ...nonRelativeValueFields,
  ]
}
